module.exports = __webpack_public_path__ + "static/app-4-cb467532b5f3412cb42c2df5813a4d4d.png";